# Intermediate View
# =====================
SupportHelpWizardController = require('../helpWizardController')
Backbone = require 'backbone'
Backbone.$ = $
SupportIntermediateViewTemplate = require('../../intermediate_view.html.mustache')

class SupportIntermediateView extends Backbone.View
	className:"intermediate_page"

	events:
		'click #about_an_order': 'redirectingToOrder'
		'click .not_about_an_order_link':'redirectSelectIssue'

	initialize: ->
		@I18nScope = 'modules.support'
		@template = SupportIntermediateViewTemplate

	render: ->
		window.hideFloatingBoldChat()
		@$el.html toHtml(@template, {}, @I18nScope)

	redirectingToOrder:()=>
		@redirectToLogin()

	redirectSelectIssue:()->
		SupportHelpWizardController.abruptStepTwoFlow()

	redirectToLogin:()->
		if window.isTouchUserAgent? && window.isTouchUserAgent && isUS()
			refUrl = window.touchSupportUrl
			window.location.href = "/login?return_to=#{encodeURIComponent(refUrl)}"
		else
			refUrl = window.SUPPORTBASEURL
			window.location.href = "/login?ref=#{encodeURIComponent(refUrl)}"

module.exports = SupportIntermediateView
